import BaseService from "./BaseService";
import { SubscriptionRequest, SubscriptionResponse, SubscriptionsResponse } from "./mappers/SubscriptionMapper";

class SubscriptionService extends BaseService {
  constructor() {
    super();
  }

  getSubscription(id) {
    return this.get(`subscriptions/${id}/`)
      .then((response) => response.data)
      .then((data) => SubscriptionResponse(data));
  }

  getSubscriptions() {
    return this.get(`subscriptions/`)
      .then((response) => response.data)
      .then((data) => SubscriptionsResponse(data));
  }

  createSubscription(data) {
    return this.post(`subscriptions/`, SubscriptionRequest(data));
  }

  updateSubscription(id, data) {
    return this.patch(`subscriptions/${id}/`, SubscriptionRequest(data));
  }

  deleteSubscription(id) {
    return this.delete(`subscriptions/${id}/`);
  }

  getSubscriptionsByIsActive() {
    return this.get(`subscriptions/active/`)
      .then((response) => response.data)
      .then((data) => SubscriptionsResponse(data));
  }
}

export default new SubscriptionService();
